import { images } from "../constants";


const Developer = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 min-h-screen font-sans">
      
      <div className="lg:col-span-4 bg-blue-900 text-white p-6 flex flex-col items-center">
        <img
          src={images.alex}
          alt="Developer"
          className="w-32 h-32 rounded-full border-4 border-white shadow-md mb-4"
        />
        <h2 className="text-2xl font-bold mb-1">Alex Mubezi Byabato</h2>
        <p className="text-sm italic mb-6">System Developer & Designer</p>

        {/* Contact */}
        <div className="w-full mb-6">
          <h3 className="text-lg font-semibold border-b border-white pb-1 mb-2">Contact</h3>
          <p className="text-sm">Email: alexmubezibyabato@gmail.com</p>
          <p className="text-sm">Phone: +255 786067253</p>
          
        </div>

        {/* Skills */}
        <div className="w-full mb-6">
          <h3 className="text-lg font-semibold border-b border-white pb-1 mb-2">Skills</h3>
          <p className="text-sm">React</p>
          <p className="text-sm">Spring Boot</p>
          <p className="text-sm">Machine Learning</p>
        </div>

        {/* Interests */}
        <div className="w-full">
          <h3 className="text-lg font-semibold border-b border-white pb-1 mb-2">Interests</h3>
          <p className="text-sm">Tech Innovation</p>
          <p className="text-sm">AI & Robotics</p>
          <p className="text-sm">System Design</p>
        </div>
      </div>

      {/* Right Side - Content */}
      <div className="lg:col-span-8 bg-white dark:bg-gray-900 text-gray-800 dark:text-white p-8">
        {/* Profile Summary */}
        <section className="mb-6">
          <h2 className="text-xl font-bold text-yellow-500 mb-2">👤 Profile</h2>
          <p className="text-sm leading-relaxed">
            Passionate developer with 5+ years' experience in full-stack development, REST APIs,
            and real-time systems. Skilled in React, Spring Boot, and Machine Learning. Dedicated to
            delivering responsive, accessible, and scalable web applications.
          </p>
        </section>

        {/* Experience */}
        <section className="mb-6">
          <h2 className="text-xl font-bold text-yellow-500 mb-2">💼 Experience</h2>
          <div className="mb-4">
            <h3 className="font-semibold text-base">Senior Developer </h3>
            <p className="text-sm text-gray-600 dark:text-gray-300">2025</p>
            <p className="text-sm">Led the design of the school website and VISIGA-SIMS at visiga seminary</p>
          </div>
          <div>
            <h3 className="font-semibold text-base">Web Developer – Freelance</h3>
            <p className="text-sm text-gray-600 dark:text-gray-300">2020 – 2024</p>
            <p className="text-sm">Built responsive systems for education and business platforms.</p>
          </div>
        </section>

        {/* Education */}
        <section className="mb-6">
          <h2 className="text-xl font-bold text-yellow-500 mb-2">🎓 Education</h2>
          <p className="text-base font-semibold">Bachelor of Computer Engineering</p>
          <p className="text-sm text-gray-600 dark:text-gray-300">DIT | Graduated: 2024</p>
        </section>

        {/* Portfolio */}
        <section className="mb-6">
          <h2 className="text-xl font-bold text-yellow-500 mb-2">📁 Portfolio</h2>
          <ul className="list-disc list-inside space-y-1 text-sm">
            <li>Smart Meter Monitoring System intergrated with ESP8266 & GSM</li>
            <li>ICT Incident Reporting System With Machine Learning</li>
            <li>Responsive Web Systems for Schools </li>
            <li>Secure Spring Boot APIs with Role-Based Access</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Developer;
